import { useStringMap } from "../../utilities/string-map/useStringMap";
import { stringMapDefault } from "./SlateRTE.stringMap";
export const useSlateRTE = (stringMapProp) => ({
    stringMap: useStringMap("SlateRTE", { stringMapDefault, stringMapProp })
});
